import React from 'react';
import { Route, Switch } from 'react-router-dom';

// constants
import appRoutes from '../../app-routes';

// screens
import { screens as HomePageScreens } from '../../modules/HomePage';
import { screens as LoginScreens } from '../../modules/Login';
import { screens as UserScreens } from '../../modules/Users';

const { HelpPage } = HomePageScreens;
const {
  HomePage: LoginPage,
  RecoverPasswordPage,
  RecoverPasswordSuccessPage,
} = LoginScreens;
const {
  SetFirstPasswordPage,
  ForgottenPasswordPage,
  RegisterPage,
  ActivateLinkPage,
} = UserScreens;

const UnauthorizedRoutes = () => {
  return (
    <Switch>
      <Route path={appRoutes.SUPPORT} component={HelpPage} />
      <Route
        path={appRoutes.RECOVER_PASSWORD}
        component={RecoverPasswordPage}
      />
      <Route
        path={appRoutes.RECOVER_PASSWORD_SUCCESS}
        component={RecoverPasswordSuccessPage}
      />
      <Route
        path={appRoutes.FORGOTTEN_PASSWORD}
        component={ForgottenPasswordPage}
      />
      <Route path={appRoutes.ACTIVATE_ACCOUNT} component={ActivateLinkPage} />
      <Route path={appRoutes.PASSWORD_SET} component={SetFirstPasswordPage} />
      <Route path={appRoutes.LOGIN} component={LoginPage} />
      <Route path={appRoutes.REGISTER} component={RegisterPage} />
      <Route path="/" component={LoginPage} />
    </Switch>
  );
};

export default UnauthorizedRoutes;
